import React, { useEffect, useState } from "react";
import TeamManagement from "./TeamManagement";
import InactiveTeams from "./InactiveTeams";
import axios from "axios";
import { base_url } from "../../utils/AxiosConfig";

const TeamManagementDashboard = () => {
  const [activeTab, setActiveTab] = useState("active");
  const [editingTeam, setEditingTeam] = useState(false);
  const [divisionListFromAPI, setDivisionListFromAPI] = useState(null);
  const [teamsList, setTeamsList] = useState(null);
  const [inactiveTeamsList, setInactiveTeamsList] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    owner: "",
    Division: "",
    members: [],
    CreatedDate: new Date(),
    isActive: true,
  });

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const companyCode = storedUserDataArray[0]?.cmpcode || null;

  useEffect(() => {
    getDivisionList();
    getTeamsList();
    getInactiveTeamsList();
  }, []);

  const getDivisionList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DIVISION/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setDivisionListFromAPI(newArray);
    } else {
      console.error("error");
    }
  };
  const getTeamsList = async () => {
    try {
      const response = await axios.get(
        `${base_url}/api/CRMTaskMainListFilter/${companyCode}/TEAMMASTFILTER/-/-/-/-/-/1900-01-01/1900-01-01/-/-/Y`,
      );

      if (!response?.data || !Array.isArray(response.data)) {
        console.error("No team data found");
        setTeamsList([]);
        return;
      }

      const teams = response.data;

      const teamsWithMembers = await Promise.all(
        teams.map(async (team) => {
          try {
            const memberResponse = await axios.get(
              `${base_url}/api/CRMTaskMainListFilter/${companyCode}/TEAMMEMPFILTER/-/-/${team.TeamID}/-/-/1900-01-01/1900-01-01/-/-/-`,
            );

            return {
              ...team,
              members: memberResponse?.data || [],
            };
          } catch (error) {
            console.error(
              `Error fetching members for TeamID ${team.TeamID}`,
              error,
            );

            return {
              ...team,
              members: [],
            };
          }
        }),
      );

      console.log("Teams With Members:", teamsWithMembers);

      setTeamsList(teamsWithMembers);
    } catch (error) {
      console.error("Error fetching teams:", error);
      setTeamsList([]);
    }
  };
  const getInactiveTeamsList = async () => {
    try {
      const response = await axios.get(
        `${base_url}/api/CRMTaskMainListFilter/${companyCode}/TEAMMASTFILTER/-/-/-/-/-/1900-01-01/1900-01-01/-/-/N`,
      );

      if (!response?.data || !Array.isArray(response.data)) {
        console.error("No team data found");
        setInactiveTeamsList([]);
        return;
      }

      const teams = response.data;

      const teamsWithMembers = await Promise.all(
        teams.map(async (team) => {
          try {
            const memberResponse = await axios.get(
              `${base_url}/api/CRMTaskMainListFilter/${companyCode}/TEAMMEMPFILTER/-/-/${team.TeamID}/-/-/1900-01-01/1900-01-01/-/-/-`,
            );

            return {
              ...team,
              members: memberResponse?.data || [],
            };
          } catch (error) {
            console.error(
              `Error fetching members for TeamID ${team.TeamID}`,
              error,
            );

            return {
              ...team,
              members: [],
            };
          }
        }),
      );

      console.log("Teams With Members:", teamsWithMembers);

      setInactiveTeamsList(teamsWithMembers);
    } catch (error) {
      console.error("Error fetching teams:", error);
      setInactiveTeamsList([]);
    }
  };

  useEffect(() => {
    if (teamsList) {
      console.log("teamsList :", teamsList);
    }
  }, [teamsList]);

  const onSaveTeam = async (editingTeam) => {
    console.log("editingTeam:", editingTeam);
    try {
      console.log("formData from active team:", formData);

      if (!formData?.name?.trim()) {
        alert("Please enter Team Name");
        return;
      }

      if (!formData?.owner?.ownerid) {
        alert("Please select Team Leader");
        return;
      }

      if (!formData?.members?.length) {
        alert("Please select at least one Team Member");
        return;
      }

      const storeduserDataArray =
        JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];

      const companyCode = storeduserDataArray?.[0]?.cmpcode || "";

      const storedLoginUserData =
        JSON.parse(localStorage.getItem("BondTimeLoginUserData")) || [];

      const userFromLocal = storedLoginUserData?.[0]?.user || "";

      const deptFromLocal = storedLoginUserData?.[0]?.DEPTNO || "";

      const currentDate = new Date().toISOString();

      const payload = formData.members.map((member) => ({
        mode: editingTeam ? "EDIT" : "ENTRY",

        cmpcode: companyCode,

        // TeamCode: "",
        TeamCode: editingTeam ? formData.TeamCode || formData.teamCode : "0",
        TeamName: formData?.name || "",

        Division: formData?.Division || "",

        jobcode: "jobcode",
        deptno: deptFromLocal,

        // TeamType: formData?.teamType || "",
        TeamType: "Sales",

        TeamLeaderID: formData?.owner?.ownerid || "",
        TeamLeaderName: formData?.owner?.ownerName || "",

        TeamDescription: formData?.description || "",

        ActiveStatus: "Y",

        // CreatedDate: currentDate,
        CreatedDate: "2026-06-04T10:00:00",
        CreatedBy: userFromLocal,

        // ModifiedDate: currentDate,
        ModifiedDate: "2026-06-04T10:00:00",
        ModifiedBy: userFromLocal,

        EmployeeID: member?.employeeId || "",
        EmployeeName: member?.name || "",

        RoleInTeam: member?.role || "",

        IsActive: member?.isActive ? "Y" : "N",
      }));

      console.log("Payload:", payload);

      const apiURL = `${base_url}/api/TeamRegister`;

      const response = await axios.post(apiURL, payload);

      console.log("Team Save Response:", response?.data);

      if (response?.status === 200 || response?.status === 201) {
        alert(
          editingTeam
            ? "Team updated successfully"
            : "Team created successfully",
        );

        // setIsOpen(false);

        // refresh team list
        // fetchTeams?.();

        // reset form
        setFormData({
          name: "",
          description: "",
          teamCode: "",
          teamType: "",
          Division: "",
          owner: null,
          members: [],
        });

        getTeamsList();
      }
    } catch (error) {
      console.error("Error saving team:", error);

      alert(error?.response?.data?.message || "Failed to save team");
    }
  };

  // const payload1 = formData.members.map((member) => ({
  //   mode: editingTeam ? "EDIT" : "ENTRY",

  //   cmpcode: companyCode,

  //   TeamCode: "SALES01",
  //   TeamName: formData?.name || "",
  //   Division: formData?.Division || "",

  //   jobcode: "MGR",
  //   deptno: "D001",

  //   TeamType: "Sales",

  //   TeamLeaderID: formData?.owner?.ownerid || "",
  //   TeamLeaderName: formData?.owner?.ownerName || "",

  //   TeamDescription: "Handles sales activities and customer acquisition.",

  //   ActiveStatus: "Y",

  //   CreatedDate: new Date().toISOString(),
  //   // CreatedBy: loginUser?.EmpId || "ADMIN",

  //   ModifiedDate: null,
  //   ModifiedBy: null,

  //   // Member-specific fields
  //   EmployeeID: member.employeeId,
  //   EmployeeName: member.name,
  //   RoleInTeam: member.role,
  //   IsActive: member.isActive ? "Y" : "N",
  // }));

  return (
    <div className="">
      <div className="flex justify-left items-center">
        <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
        <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4 ">
          <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
            TEAM MANAGEMENT
          </span>
        </h6>

        <div className="w-60">
          {/* <label className="block text-sm font-medium mb-1 flex items-center">
            Division
          </label> */}

          <div className="ml-14 flex justify-between items-center gap-2">
            <select
              className="placeholder-gray-400 w-full px-3 py-2 text-sm bg-white  rounded bg-[#F9FAFA] border border-gray-200 "
              value={formData?.Division || ""}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  Division: e.target.value,
                })
              }
            >
              <option>--Select Division--</option>
              {divisionListFromAPI?.map((item, index) => (
                <option value={item.Description} key={index}>
                  {item.Description}
                </option>
              ))}
            </select>

            {/* <button
              type="button"
            //   onClick={() => setShowDepartmentCreationEditPopup(true)}
              className="bg-blue-500 hover:bg-blue-700 px-2 py-1 text-white font-semibold rounded-md text-sm"
            >
              Manage
            </button> */}
          </div>
        </div>
      </div>{" "}
      <main className="w-full mt-4 relative">
        <div className="  overflow-hidden">
          {/* Tabs Header */}
          <div className="  flex border-b border-gray-200 ">
            <button
              onClick={() => setActiveTab("active")}
              className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${
                activeTab === "active"
                  ? "border-blue-600 text-blue-600 "
                  : "border-transparent text-gray-600 hover:text-gray-800"
              }`}
            >
              Active Teams
            </button>

            <button
              onClick={() => setActiveTab("inactive")}
              className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${
                activeTab === "inactive"
                  ? "border-blue-600 text-blue-600 "
                  : "border-transparent text-gray-600 hover:text-gray-800"
              }`}
            >
              Inactive Teams
            </button>
          </div>

          {/* Content */}
          <div className="">
            {activeTab === "active" && (
              <TeamManagement
                formData={formData}
                setFormData={setFormData}
                onSaveTeamParent={onSaveTeam}
                teams={teamsList}
                setTeams={setTeamsList}
                editingTeamBoolean={editingTeam}
                setEditingTeamBoolean={setEditingTeam}
                fetchActiveList={getTeamsList}
              />
            )}

            {activeTab === "inactive" && (
              <InactiveTeams
                teams={inactiveTeamsList}
                setTeams={setInactiveTeamsList}
                fetchInactiveList={getInactiveTeamsList}
              />
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default TeamManagementDashboard;
